import { useContext } from "react";
import axios, { HttpStatusCode } from "axios";

import AuthContext from "common/store/AuthContext";

import { generateErrorMsg, genApiDatePath, getServerUrl } from "utils/commonTools";
import { PostResponse } from "common/types/responses/BasicResponse";
import { LastUpdatedInfo } from "common/types/LastUpdatedInfo";

import { REPORT_TYPE } from "common/types/consts/Defines";
import { LockStatus } from "common/types/LockStatus";

export const useLock = () => {
  const authCtxt = useContext(AuthContext);
  const { token } = authCtxt;

  /**
   * ロック状態の取得
   * @param parkId
   * @param date
   */
  const getLockStatus = async (parkId: number, date: Date): Promise<LockStatus | undefined> => {
    const config = {
      headers: { "Content-type": "application/json", Authorization: `Bearer ${token}` },
    };

    try {
      const { data } = await axios.get<LockStatus>(
        getServerUrl() + `common/report/lock/${parkId}/${genApiDatePath(date)}`,
        config
      );
      return data;
    } catch (error) {
      console.log("ロック状態の取得でエラー", error);
      return undefined;
    }
  };

  //--------------------------------------
  // ロック処理の実行
  //--------------------------------------
  const setLock = async (
    parkId: number,
    reportType: REPORT_TYPE,
    apiPath: string,
    date: Date,
    lock: boolean
  ): Promise<{ succeeded: boolean; msg: string; lastUpdated?: LastUpdatedInfo }> => {
    const config = {
      headers: { "Content-type": "application/json", Authorization: `Bearer ${token}` },
    };
    try {
      const url =
        getServerUrl() +
        `${apiPath}/lock/${parkId}/${reportType}/${genApiDatePath(date)}/${lock ? 1 : 0}`;
      const response = await axios.post(url, {}, config);
      if (response.status === HttpStatusCode.NoContent) {
        return { succeeded: false, msg: "データが登録されていません" };
      }

      const responseData = response.data as PostResponse;
      if (!responseData) {
        return { succeeded: false, msg: "取得したデータに異常がありました" };
      }

      authCtxt.updateToken(responseData.token, new Date(responseData.expiresAt));

      return { succeeded: true, msg: "" };
    } catch (error: unknown) {
      var errMsg = generateErrorMsg(error);
      return { succeeded: false, msg: errMsg };
    }
  };

  return { getLockStatus, setLock };
};
